import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { useQuery } from 'react-query';
import { ImageType } from '@types';
import { API_DOMAIN } from '@constants';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import axios from '@utils/axios';
import ImgModel from './img-model.png';

interface Props {
  tid: string;
  listIndex: number;
  onDelete: (index: number) => void;
}

type ModelItem = {
  tid: string;
  name: string;
  thumbUrl: string;
};

function Item({ tid, listIndex, onDelete }: Props) {
  const { data } = useQuery(
    ['libItemModel3D', tid],
    () => axios.get<ModelItem>(`${API_DOMAIN}/3dmodel/${tid}/json`),
    {
      retry: 0,
      onError: () => {
        onDelete(listIndex);
      },
    }
  );

  return (
    <div className="relative mb-10 flex h-35 select-none items-center rounded bg-black-border px-10">
      {!!data && (
        <>
          <Image
            src={data.thumbUrl || ImgModel}
            size={16}
            type={data.thumbUrl ? ImageType.thumb : undefined}
            className="h-16 w-16 bg-[#efefef]"
          />
          <div className="mx-5 flex-grow truncate text-base text-white">
            {data.name}
          </div>
          <IconTrash
            className="flex-shrink-0"
            onClick={() => onDelete(listIndex)}
          />
        </>
      )}
    </div>
  );
}

export default SortableElement(Item);
